import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireAuth({ children, roles }) {
    const { user, token } = useAuth();
    const location = useLocation();

    if (!token) {
        // not signed in
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    if (roles && roles.length && (!user || !roles.includes(user.role))) {
        // signed in, but not authorized
        return <Navigate to="/" replace />;
    }
    return children;
}
